export default "__VITE_ASSET__AjJtEbEF__"